import api from "../api/Axios"; 
import { getAccessToken } from "../utils/tokenManager";

const API_URL = '/prices';

const priceService = {
  getActivePrices: async () => {
    try {
      const response = await api.get(`${API_URL}/active`, {
        headers: { Authorization: `Bearer ${getAccessToken()}` }
      });
      return response.data?.data || [];
    } catch (error) {
      throw error;
    }
  },
  setPrice: async (payload) => {
    try {
      const response = await api.post(API_URL, payload, {
        headers: { Authorization: `Bearer ${getAccessToken()}` }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default priceService;